import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import * as Map from 'immutable';
import Scrollbar from 'react-scrollbars-custom';
import { _change_remark_modal } from '../../store/Action';
import { Modal, Button, Input, message } from 'antd';
import HTTP from '../../script/service';
import './SetRemark.scss';
import { DDLoading } from '../globalPageStatus';

class SetRemark extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      name: '',
      ds: {},
      callback: () => {},
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.setRemark_visible);
    const props2 = Map.fromJS(this.props.base.setRemark_visible);
    if (this.props.base.setRemark_visible && !Map.is(props1, props2)) {
      this.showModal(this.props.base.setRemark_data);
    }
  }
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  //完成
  handleSubmit = () => {
    const { name, ds, callback } = this.state;

    let remarkName = name?.trim() || null;

    HTTP._set_friend_remark({
      toUid: ds.uid,
      remarkName,
    }).then((res) => {
      if (res.code == 200) {
        callback && callback(name);
        this.hideModal();
        message.success('备注成功');
      } else {
        message.error(res.message);
      }
    });
  };

  showModal = (record) => {
    this.setState({
      visible: true,
      name: record?.remarkName || '',
      ds: record || {},
      callback: record?.callback,
    });
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_remark_modal({
      show: false,
    });
  };

  render() {
    const { loading, name, ds } = this.state;
    return (
      <Modal
        open={this.state.visible}
        zIndex={1002}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        title={`设置备注`}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="400px"
        onCancel={this.hideModal}
      >
        <DDLoading status={loading} className="set-plan-spin">
          <div className="set-remark">
            <Scrollbar className="my-scroll-bar">
              <div className="remark-name">
                <Input
                  placeholder="请填写备注名，最长9个字符"
                  style={{ backgroundColor: '#2f2f4a' }}
                  value={name}
                  defaultValue={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  maxLength={9}
                  showCount={true} 
                  allowClear
                />
              </div>
              <h3>用户昵称：{ds.nickName}</h3>
              <div style={{ textAlign: 'center' }}>
                <Button
                  className="daidai-btn-primary"
                  style={{
                    padding: '0 140px',
                    marginTop: '80px',
                    height: '44px',
                    borderRadius: '30px',
                  }}
                  onClick={this.handleSubmit}
                >
                  保存
                </Button>
              </div>
            </Scrollbar>
          </div>
        </DDLoading>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(SetRemark, { withRef: true })
);
